import React, { Component } from "react";
import classNames from "classnames";
import ReactSuperSelect from "react-super-select";
import DropdownCheckboxes from "ReactComponents/Shared/FormInputs/dropdown-checkboxes";
import { productPickerComposer } from "ReactReducers/ProductPicker/product-picker-composer";
import Modal from "ReactComponents/Modal/modal";

class ProductPickerSelectedDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tempAmount: 0,
            showClassSelector: false,
            infoModalShow: false
        };
        this.selectChangeHandler = this.selectChangeHandler.bind(this);
        this.classSelectorVisible = this.classSelectorVisible.bind(this);
        this.classSelectorSubmitHandler = this.classSelectorSubmitHandler.bind(this);
        this.openInfoModal = this.openInfoModal.bind(this);
        this.closeInfoModal = this.closeInfoModal.bind(this);
    }

    openInfoModal() {
        this.setState({ infoModalShow: true });
    }

    closeInfoModal() {
        this.setState({ infoModalShow: false });
    }

    selectChangeHandler(objectSelected, ArrayOfChoices) {
        for (let i = 0; i < ArrayOfChoices.length; i++) {
            if (
                ArrayOfChoices[i].UnitValue == objectSelected.UnitValue &&
                ArrayOfChoices[i].UnitTypeCode == objectSelected.UnitTypeCode
            ) {
                this.props.setPeriodValueIndex(i);
                return;
            }
        }
    }

    classSelectorVisible(value) {
        this.setState({
            showClassSelector: value
        });
    }

    classSelectorSubmitHandler(value) {
        this.classSelectorVisible(false);
        this.props.setClassesValue(value);
    }

    getPriceBasisText() {
        const c = this.props.configs;
        const classOptions = c.ClassOptions.Options;
        const relevantClasses =
            this.props.product.RelevantClasses && this.props.product.RelevantClasses.Classes;

        if (c.IsSchoolLicenseAndRelevantClasses && relevantClasses) {
            // Price based on relevant classes
            const generateString = () => {
                const classCount = relevantClasses && relevantClasses.length;
                let preText = "";
                //TODO: maybe get flag from Sitecore if price configuration is pr. student?
                const isPriceUnitStudent = this.props.product.PriceUnit.includes("elev");

                if (isPriceUnitStudent) {
                    let studentCount = 0;
                    relevantClasses &&
                        relevantClasses.map(item => {
                            studentCount += item.StudentCount;
                        });
                    preText = studentCount + " " + this.props.labels.StudentsLabel;
                } else {
                    preText = classCount + " " + this.props.labels.ClassesLabel;
                }

                return (
                    <span>
                        {preText} (
                        {relevantClasses &&
                            relevantClasses.map((item, index) => {
                                const after = index + 1 == classCount ? "" : ", ";
                                return (
                                    <span key={index}>
                                        {item.ClassName}
                                        {after}
                                    </span>
                                );
                            })}
                        )
                    </span>
                );
            };

            return generateString();
        } else if (c.ShowClassDropdown) {
            // Price based on custom selected classes
            const classes = classOptions.filter(item => item.Selected);
            const numStudents = classes && classes.map(item => item.Value).reduce((a, b) => a + b, 0);
            return c.PriceBasisText.replace(/\{0\}/g, classes.length).replace(/\{1\}/g, numStudents);
        } else {
            const numStudents =
                classOptions && classOptions.map(item => item.Value).reduce((a, b) => a + b, 0);
            return c.PriceBasisText.replace(/\{0\}/g, classOptions.length).replace(/\{1\}/g, numStudents);
        }
    }

    render() {
        //const product = this.props.product;
        const c = this.props.configs;

        const customSelectedValueTemplate = arr => {
            const obj = arr[0];
            return (
                <div className="custom-selected-template">
                    <span>{obj.AccessPeriodText}</span>
                    <span>{obj.PriceText}</span>
                </div>
            );
        };

        const customOptionTemplate = obj => {
            return (
                <div className="custom-selected-template">
                    <span>{obj.AccessPeriodText}</span>
                    <span>{obj.PriceText}</span>
                </div>
            );
        };

        const periodSelectHandler = objSelected => {
            if (objSelected) {
                this.selectChangeHandler(objSelected, c.PeriodOptions);
            }
        };

        const renderSelectClassesButton = selectedClasses => {
            const hasSelectedClasses = selectedClasses.length > 0;
            const btnClasses = classNames({
                "button button--slim": true,
                "button-primary": !hasSelectedClasses,
                "button-secondary": hasSelectedClasses
            });
            const btnText = hasSelectedClasses ? c.EditSelectedLevels : c.ChooseSelectedLevelsText;
            return (
                <button
                    type="button"
                    className={btnClasses}
                    onClick={() => {
                        this.classSelectorVisible(true);
                    }}
                >
                    {btnText}
                </button>
            );
        };

        const renderConfigInputInfo = () => {
            const showPeriodDropdown = c.PeriodOptions.length && c.PeriodOptions.length > 1;
            // default selected
            const selectedPeriodObject = c.PeriodOptions.filter(item => {
                return item.Selected;
            })[0];
            const selectedClasses = c.ClassOptions.Options.filter(obj => obj.Selected).map(obj => obj.Label);

            return (
                <div>
                    {c.ShowClassOptions && (
                        <div className="product-picker__item__info__row">
                            <div className="full">
                                <DropdownCheckboxes
                                    dataSource={c.ClassOptions.Options}
                                    onChange={this.classSelectorSubmitHandler}
                                    expanded={this.state.showClassSelector}
                                    closeFunction={this.classSelectorVisible}
                                    selectBtnText={c.ConfigurationSelect}
                                />
                                <div className="product-picker__choose-classes-wrapper">
                                    {renderSelectClassesButton(selectedClasses)}
                                </div>
                            </div>
                        </div>
                    )}
                    {showPeriodDropdown && (
                        <div className="product-picker__item__info__row vertical-align tall">
                            <div className="full">
                                <ReactSuperSelect
                                    dataSource={c.PeriodOptions}
                                    onChange={periodSelectHandler}
                                    placeholder={c.ChoosePeriodText}
                                    initialValue={selectedPeriodObject}
                                    optionValueKey="PrimaryUnitPrice"
                                    optionLabelKey="TotalPriceLabel"
                                    customOptionTemplateFunction={customOptionTemplate}
                                    customSelectedValueTemplateFunction={customSelectedValueTemplate}
                                />
                            </div>
                        </div>
                    )}
                </div>
            );
        };

        const renderSummaryInfo = () => {
            const hasContent = c.AccessText || c.AccessPeriodText || c.AccessRenewText;
            const priceBasisNotification = c.IsSchoolLicenseAndRelevantClasses
                ? this.props.labels.PriceBasisNotification
                : null;

            return (
                <div>
                    {hasContent && (
                        <div className="product-picker__item__info__row tall">
                            <table className="product-picker-table">
                                <tbody>
                                    {c.AccessLabel && c.AccessText && (
                                        <tr>
                                            <td>{c.AccessLabel}</td>
                                            <td className="u-text-align-right">
                                                {c.AccessText.replace(/\{0\}/g, this.props.amount)}
                                            </td>
                                        </tr>
                                    )}
                                    {c.AccessPeriodLabel && !!c.AccessPeriodText && (
                                        <tr>
                                            <td>{c.AccessPeriodLabel}</td>
                                            {c.PeriodOptions.length > 1 &&
                                            this.props.isGettingProductPrice ? (
                                                <td className="u-text-align-right">
                                                    <div className="loader">
                                                        <span></span>
                                                    </div>
                                                </td>
                                            ) : (
                                                <td className="u-text-align-right">{c.AccessPeriodText}</td>
                                            )}
                                        </tr>
                                    )}
                                    {c.AccessRenewLabel && c.AccessRenewText && (
                                        <tr>
                                            <td>{c.AccessRenewLabel}</td>
                                            <td className="u-text-align-right">{c.AccessRenewText}</td>
                                        </tr>
                                    )}
                                    {c.PriceBasisLabel && (
                                        <tr>
                                            <td>{c.PriceBasisLabel}</td>
                                            {this.props.isGettingProductPrice ? (
                                                <td className="u-text-align-right">
                                                    <div className="loader">
                                                        <span></span>
                                                    </div>
                                                </td>
                                            ) : (
                                                <td className="u-text-align-right">
                                                    {this.getPriceBasisText()}
                                                </td>
                                            )}
                                        </tr>
                                    )}
                                    {c.ShowClassOptions &&
                                        !c.PriceBasisLabel &&
                                        this.props.isGettingProductPrice && ( // First time getting PriceBasisText for class license
                                            <tr>
                                                <td></td>
                                                <td className="u-text-align-right">
                                                    <div className="loader">
                                                        <span></span>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {priceBasisNotification && (
                        <div className="product-picker__item__info__row vertical-align">
                            <div
                                className="full product-picker__note"
                                dangerouslySetInnerHTML={{ __html: priceBasisNotification }}
                            />
                        </div>
                    )}
                </div>
            );
        };

        return (
            <div className="product-picker-selected-details">
                {(c.LicenseLabel != null || c.LicenseText != null) && (
                    <div>
                        <div className="product-picker__item__info__row vertical-align">
                            <div className="left">
                                <span className="product-picker__item__info__row__header">
                                    {c.LicenseLabel}
                                </span>
                                {c.LicenseTypeText && !c.LicenseText && (
                                    <span className="u-text-space-left">{c.LicenseTypeText}</span>
                                )}
                                {c.LicenseTypeText && c.LicenseText && (
                                    <div className="product-picker__note">{c.LicenseTypeText}</div>
                                )}
                            </div>
                            {/* TODO: Should be the institution, but we are not getting any. Change design for LicenseTypeText, if we'll get LicenseText! */}
                            {c.LicenseText && (
                                <div className="right product-picker__note">{c.LicenseText}</div>
                            )}
                        </div>
                        <hr />
                    </div>
                )}

                {!c.IsBuyable && c.BuyableNote && (
                    <div className="product-picker__item__info__row">
                        <div className="full" dangerouslySetInnerHTML={{ __html: c.BuyableNote }} />
                    </div>
                )}

                {c.IsBuyable && (
                    <div>
                        {renderSummaryInfo()}
                        {renderConfigInputInfo()}
                    </div>
                )}

                {c.PriceInfoLinkText && <hr />}
                {c.PriceInfoLinkText && (
                    <div className="product-picker__item__info__row">
                        <div className="full">
                            <div className="content-info">
                                <button type="button" className="link-button" onClick={this.openInfoModal}>
                                    {c.PriceInfoLinkText}
                                </button>
                                <Modal
                                    isOpen={this.state.infoModalShow}
                                    toClose={this.closeInfoModal}
                                    showCloseButton
                                    labelledBy="price-info-title"
                                >
                                    <div
                                        className="content-rich-text"
                                        id="price-info-title"
                                        dangerouslySetInnerHTML={{ __html: c.PriceInfoContentText }}
                                    />
                                </Modal>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default productPickerComposer(ProductPickerSelectedDetails);
